import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPublicTournament,
} from "../../reducers/tournamentSlice";
import {
  applyDiscountThunk,
  selectCompletedOrder,
  selectRegistrationCustomer,
  selectRegistrationOrder,
  updateOrderThunk,
} from "../../reducers/registrationOrderSlice";
import {
  defaultGapping,
  defaultLayouts,
  GSButton,
  GSInput,
} from "golfstatus_react_components";
import { useTheme } from "../../hooks/themeHooks";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import SummaryLineItem from "../events/event/cart/summary-line-item";
import { moneyWithCommas } from "../../helpers/RegexHelper";
import { CREDIT_CARD } from "../../forms/CartSections";

const CheckoutDiscountWidget = (props) => {
  

  const {complete} = props
    const completedOrder = useSelector(selectCompletedOrder)
    const inProgressOrder = useSelector(selectRegistrationOrder)
    const registrationOrder = complete ? completedOrder : inProgressOrder 

    const registrationCustomer = useSelector(selectRegistrationCustomer)
  
  const [discountCode, setDiscountCode] = useState("");

  const dispatch = useDispatch();

  const tournament = useSelector(selectPublicTournament);

  const discount = registrationOrder?.discountCodes?.[0];
 
  const [, theme, getStyle] = useTheme();

  const addDiscount = () => {
    const ru =
      registrationOrder?.donationOrderItems
        ?.filter?.((d) => d?.roundUp)
        ?.map?.((d) => {
          return { round_up: true };
        }) ?? [];
    const don =
      registrationOrder?.donationOrderItems
        ?.filter?.((d) => !d?.roundUp)
        ?.map?.((d) => {
          return { id: d?.id, amount: d?.amount };
        }) ?? [];

    dispatch(
      applyDiscountThunk({
        tournamentID: tournament?.id,
        discountCode,
        registrationOrder: {
          ...registrationOrder,
          donationOrderItems: [...ru, ...don],
          registrationCustomer
        },

      })
    );
  };

  const removeDiscountCode = () => {

    const update = {
      ...registrationOrder,
      discountCode: null,
      registrationCustomer,
      paymentType: registrationOrder?.paymentType ?? CREDIT_CARD
    };

    dispatch(updateOrderThunk(update));
  };

  const getDiscountText = () => {
    if(discount?.dollarAmount){
      return `-${moneyWithCommas(discount?.discountDollarAmount)}`
    }
    if(discount?.discountPercent){
      return `-${discount?.discountPercent}%`
    }
  }

  const getView = () => {
    if (!complete) {
      if ((discount?.code ?? "") === "") {
        return (
          <div
            style={{
              ...defaultLayouts.hStack.align("flex-start", "center"),
              ...defaultLayouts.fullWidth,
              ...defaultGapping.largeGap,
            }}
          >
            <GSInput
              textValue={discountCode}
              style={{
                ...defaultLayouts.fullWidth,
                ...getStyle(theme.surface),
              }}
              placeholder="Discount Code"
              onChange={(e) => {
                setDiscountCode(e?.target?.value);
              }}
            />
            <GSButton
              isFocusable={true}
              title="Apply"
              type="black"
              isDisabled={(discountCode ?? "") === ""}
              onClick={() => {
                addDiscount();
              }}
            />
          </div>
        );
      }
      return (
        <GSButton
          title="remove"
          buttonIcon={faTimesCircle}
          type="grey secondary"
          onClick={() => {
            removeDiscountCode();
          }}
        />
      );
    }
  };

  return (
    <SummaryLineItem
      style={{ ...defaultLayouts.fullWidth }}
      label="Discount"
      description="Optional"
      value={
        getDiscountText()
      }
      content={getView()}
    />
  );
};

export default CheckoutDiscountWidget;
